// extracted by mini-css-extract-plugin
export default {"cartActionsBtn":"AddToCart_cartActionsBtn__KsL5G","active":"AddToCart_active__+HLbU"};